<mat-form-field [ngStyle]="styles" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input matInput [matAutocomplete]="auto" type="text" [formControl]="control" (focus)="onShowSuggestions(control.value ?? '')" />
</mat-form-field>
<mat-autocomplete #auto="matAutocomplete">
  <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion">
    {{ suggestion }}
  </mat-option>
</mat-autocomplete>
